import { render, staticRenderFns } from "./paramsBuild.vue?vue&type=template&id=17bfd02f&"
import script from "./paramsBuild.vue?vue&type=script&lang=js&"
export * from "./paramsBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports